<div class="page-section-header">{{ title() | translate }}</div>
